import { render, staticRenderFns } from "./past-invasions-list.vue?vue&type=template&id=20a1021c&scoped=true&lang=pug&"
import script from "./past-invasions-list.vue?vue&type=script&lang=js&"
export * from "./past-invasions-list.vue?vue&type=script&lang=js&"
import style0 from "./past-invasions-list.vue?vue&type=style&index=0&id=20a1021c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1021c",
  null
  
)

export default component.exports